import { Flex, Text } from '@radix-ui/themes';
import React from 'react';
import Link from 'next/link';
interface Props {
    title: string;
    value: string;
    Icon: React.FC;
    subtitle?: string;
    href?: string;
}

const StatisticPanel = ({
    title,
    value,
    subtitle,
    Icon,
    href,
}: Props) => {
    const content = (
        <Flex
            justify="between"
            className="rounded-lg bg-zinc-100 p-6 pr-4 pb-4 h-min"
        >
            <Flex direction="column">
                <Text className="text-sm font-semibold pb-3">{title}</Text>
                <Text className="text-2xl font-bold">{value}</Text>
                {subtitle && <Text className="text-sm text-muted-foreground -translate-y-1">
                    {subtitle}
                </Text>}
            </Flex>
            <Flex>
                <Icon />
            </Flex>
        </Flex>
    );

    return href ? (
        <Link href={href ?? ''}>{content}</Link>
    ) : (
        <div>{content}</div>
    );
}

export default StatisticPanel
